import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: '450px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  section: {
    width: '100%',
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: 'rgb(1, 70, 81)',
    fontSize: '1rem',
  },
  cardTitle: {
    marginTop: theme.spacing(3),
  },
  paper: {
    backgroundColor: 'transparent',
    '& .MuiFormControl-root': {
      marginBottom: theme.spacing(1.5),
      position: 'relative',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& .MuiInputBase-root': {
      borderRadius: 8,
      height: '48px',
      backgroundColor: '#fff',
      fontSize: '1rem',
      fontWeight: 500,
      color: theme.oysterTheme.extraGrey,
      '& input': {
        height: '48px',
        padding: '0 14px',
        fontSize: '1rem',
        color: theme.oysterTheme.extraGrey,
        fontWeight: 500,
        '&::placeholder': {
          color: 'transparent',
        },
        '&:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px white inset',
          backgroundColor: `${theme.oysterTheme.cotton} !important`,
        },
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1px solid ${theme.oysterTheme.stone}`,
      },
      '&:hover fieldset': {
        borderColor: `${theme.oysterTheme.stone} !important`,
        borderWidth: '1px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: `${theme.oysterTheme.stone} !important`,
        borderWidth: '1px !important',
      },
      '&.Mui-error fieldset': {
        border: `1px solid ${theme.oysterTheme.ferrari} !important`,
      },
    },
    '& .MuiInputLabel-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      height: '100%',
      textAlign: 'left',
      fontSize: '1rem',
      color: theme.oysterTheme.extraGrey,
      fontWeight: 500,
      transform: 'translate(14px, 16px) scale(1)',
      '&.Mui-focused': {
        transform: 'translate(14px, -6px) scale(0.75) !important',
        color: `${theme.oysterTheme.shark} !important`,
      },
      '&.MuiInputLabel-shrink': {
        width: '100%',
        color: theme.oysterTheme.shark,
        transform: 'translate(14px, -6px) scale(0.75) !important',
      },
      '&.Mui-error': {
        color: `${theme.palette.error.main} !important`,
      },
    },
  },
  formContent: {
    padding: 0,
  },
  tabs: {
    marginBottom: theme.spacing(2),
    '& .MuiTabs-fixed': {
      '& button': {
        marginLeft: 10,
        [theme.breakpoints.up('sm')]: {
          marginLeft: 20,
        },
      },
      '& button:first-child': {
        marginLeft: 0,
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tab: {
    minWidth: 'auto',
    maxWidth: '50%',
    minHeight: 66,
    border: 'solid 1px',
    borderColor: theme.oysterTheme.stone,
    borderRadius: 10,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.oysterTheme.charcoal,
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      alignItems: 'start',
    },
    '&.Mui-selected': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    '& svg': {
      fontSize: '1.125rem',
      marginRight: theme.spacing(1),
      marginBottom: '0 !important',
    },
  },
  formContainer: {
    padding: 0,
    marginTop: theme.spacing(2),
  },
  brands: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1em',
    marginBottom: theme.spacing(3),
    '& .brand': {
      '&.visa': {
        width: 70,
      },
      '&.mastercard': {
        height: 28,
      },
      '&.amex': {
        height: 30,
      },
    },
  },
  methodIcon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
  },
  paymentButton: {
    width: '100%',
    height: '42px',
    borderRadius: '4px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.938rem',
    marginTop: theme.spacing(2),
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#000',
      opacity: 0.9,
    },
  },
  applePayButton: {
    width: '100%',
    height: '42px',
    borderRadius: '4px',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginBottom: theme.spacing(2),
    '&:hover': {
      opacity: 0.9,
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
    '&::before, &::after': {
      borderColor: '#e0e0e0',
    },
  },
  orText: {
    color: '#6b7280',
    fontSize: '0.875rem',
    textAlign: 'center',
    margin: theme.spacing(2, 0),
  },
}));
